import { getIncidentTypeLabel } from "@/lib/utils/matters/incident-classification";
import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { IncidentType } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type IncidentTypeContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  incidentType: IncidentType;
  onDelete: () => void;
  onEdit: () => void;
  trigger: ReactNode;
};

export function IncidentTypeContextMenu({
  canDelete,
  canEdit,
  incidentType,
  onDelete,
  onEdit,
  trigger,
}: IncidentTypeContextMenuProps) {
  return (
    <ContextMenu
      entityName="incident type"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(
                getIncidentTypeLabel(incidentType),
                "Incident type label",
              );
            }}
          >
            <Clipboard />
            Copy incident type label
          </ContextMenuItem>
          <ContextMenuItem
            disabled={!incidentType.description}
            onSelect={() => {
              void copyToClipboard(
                incidentType.description ?? "",
                "Incident type description",
              );
            }}
          >
            <Clipboard />
            Copy description
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
